import { formatCurrency } from '@/shared/infra/format'

export function formatCurrencyFromMinorUnits(amount: number, currencyCode?: string): string {
  return formatCurrency(amount / 100, currencyCode)
}
